module.exports = __webpack_public_path__ + "assets/reorder-down.6dd39c72.svg";